<template>
  <div class="nav">
    <div class="sn-nav-back">
      <a class="sn-back" href="javascript:;" onClick="javascript:history.back(-1);"></a>
      <div class="title">{{titleName}}</div>
      <span :name="saCity" @click="showCity" class="t-city" v-if="city">{{city}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name:"TopNav",
    props: {
      titleName:{
        type: String
      },
      city:{
        type: String
      },
      saCity: {
        type: String
      }
    },
    methods: {
      showCity() {
        this.$emit('listenChild', {
          showCity: true
        });
      }
    }
  }
</script>

<style scoped>
  .nav{
    background: #FFAA00;
  }
  .sn-nav-back{
    z-index: 10;
    position: relative;
    height: 1.76rem;
    line-height: 1.76rem;
    font-size: .68rem;
    width: 100%;
    margin: 0;
    left:0;
    a{
      height: 1.76rem;
      z-index: 100;
    }
  }
  .sn-nav-back:before{
    border: solid #fff;
    border-width: 3px 0 0 3px;
    -webkit-transform: rotate(-45deg);
    left: .49rem;
  }
  .title{
    font-family:PingFangSC-Semibold;
    text-align: center;
    color:#ffffff;
    position: relative;
  }
  .t-city {
    padding-right: 20px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #FFFFFF;
    position: absolute;
    right: 38px;
    height: 1.76rem;
    line-height: 1.76rem;
    display: block;
    top: 0;
    &:after {
       content: '';
       right: -10px;
       top: 31px;
       position: absolute;
       width: 12px;
       height: 12px;
       border: 1px solid #fff;
       border-top: none;
       border-right: none;
       transform: rotate(-45deg);
     }
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/TopNav.vue